<template>
	<AppButton variant="secondary" :border="computedBorder" :size="size" :is-outline="isOutline" :is-soft="isSoft" :is-icon-only="isIconOnly" :is-active="isActive" :is-toggle="isToggle" :is-disabled="isDisabled" :is-loading="isLoading" :is-ripple="isRipple" :label="label" v-bind="$attrs">
		<slot />
	</AppButton>
</template>

<script>
import AppButton from "../AppButton.vue";
import { mapGetters } from "vuex";

export default {
	name: "SecondaryButton",
	components: { AppButton },
	props: {
		size: String,
		isOutline: Boolean,
		isSoft: Boolean,
		isIconOnly: Boolean,
		isActive: Boolean,
		isToggle: Boolean,
		isDisabled: Boolean,
		isLoading: Boolean,
		isRipple: {
			type: Boolean,
			default: true,
		},
		label: {
			type: String,
			default: "",
		},
		border: {
			type: String,
			default: null,
		},
	},
	computed: {
		...mapGetters("ui", ["buttonBorder"]),
		computedBorder() {
			return this.border || this.buttonBorder || "rounded";
		},
	},
};
</script>
